/* Models */
import { Channel } from '../models';

/* ActionTypes */
import { CHANNEL_ENTITY_ACTION_TYPES } from './actionTypes';

/* Utils */
import { generateEntityReducer } from '../utils/generators/reducerGenerators';

const stationsReducer = generateEntityReducer(CHANNEL_ENTITY_ACTION_TYPES, Channel);

export default stationsReducer;
